module.exports = __webpack_public_path__ + "static/media/icon-moon.5947fcb1.svg";